import { useEffect } from 'react';
import { useEditorStore } from '@/stores/editor-store';

/** Keyboard shortcuts for the editor */
export function useEditorShortcuts() {
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      const state = useEditorStore.getState();

      // Don't intercept if user is typing in an input
      if (e.target instanceof HTMLInputElement || e.target instanceof HTMLTextAreaElement) return;

      // Paste mode shortcuts
      if (state.isPasting) {
        if (e.key === 'Enter') {
          e.preventDefault();
          state.confirmPaste();
          return;
        }
        if (e.key === 'Escape') {
          e.preventDefault();
          state.cancelPaste();
          return;
        }
        return;
      }

      // Ctrl/Cmd shortcuts
      if (e.ctrlKey || e.metaKey) {
        switch (e.key.toLowerCase()) {
          case 'z':
            e.preventDefault();
            if (e.shiftKey) {
              state.redo();
            } else {
              state.undo();
            }
            return;
          case 'y':
            e.preventDefault();
            state.redo();
            return;
          case 'c':
            if (state.selection) {
              e.preventDefault();
              state.copySelection();
            }
            return;
          case 'v':
            if (state.clipboard) {
              e.preventDefault();
              state.startPaste();
            }
            return;
        }
        return;
      }

      // Tool shortcuts (single key, no modifier)
      if (!e.ctrlKey && !e.metaKey && !e.altKey) {
        switch (e.key.toLowerCase()) {
          case 'b':
            state.setActiveTool('pencil');
            return;
          case 'e':
            state.setActiveTool('eraser');
            return;
          case 'g':
            state.setActiveTool('fill');
            return;
          case 'i':
            state.setActiveTool('eyedropper');
            return;
          case 'm':
            state.setActiveTool('select');
            return;
          case 'escape':
            state.setSelection(null);
            return;
        }
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, []);
}
